import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useViewport } from '../../context/ViewportContext';

// Components
import Header from "../Header/Header";
import HeroCarousel from "../HeroCarousel/HeroCarousel";
import FPproducts from "./FPproducts";
//import Test from "../Test/Test2"
//import CookieConsent from "../Helper/CookieConsent"


// Redux actions - FIXED PATH
import { 
  fetchCarouselData, 
  toggleMenu, 
  closeMenu 
} from "../../store/frontPageSlice";

// Hooks
import { useMenu } from "../../hooks/useMenu"; // ADDED

// Styles
import "../../assets/css_axl/style3.css";

const AxlFrontPage = () => {
  const { isMobile } = useViewport();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Use custom menu hook instead of Redux selector directly
  const { isMenuOpen, toggleMenu: handleToggleMenu, closeMenu: handleCloseMenu } = useMenu();

  // Fetch data on component mount
  useEffect(() => {
    dispatch(fetchCarouselData());
  }, [dispatch]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 to-gray-100">
      {/* Header */}


      {/* Hero Carousel */}
      <HeroCarousel />

{/* subtle divider */}
<div className="h-1 bg-gradient-to-r from-transparent via-[#5c67aa] to-transparent opacity-50"></div>

<div className="text-center bg-white p-6">
        <h3 className="text-[#0a2540] text-2xl md:text-4xl font-light"
            style={{
              textShadow: `
                1px 1px 0 rgba(10, 37, 64, 0.05),
                2px 2px 0 rgba(10, 37, 64, 0.05),
                3px 3px 0 rgba(10, 37, 64, 0.05),
                0 0 12px rgba(10, 49, 97, 0.2)
              `
            }}>
          Extraordinary OCXO products: "Atomic" stability at lowest consumption
        </h3>
      </div> 

<div className="h-1 bg-gradient-to-r from-transparent via-[#5c67aa] to-transparent opacity-50"></div>








      {/* Main Content */}

      <MainContent />

    </div>
  );
};

// Separate Main Content Component for better readability
const MainContent = () => {
  return (
    <>
      <div className="space-y-8 mb-8 ">
        {/* Use filter() instead of find() to get an array */}
       
        

      </div>
      <div className="-mt-8">
          <FPproducts />
      </div>
      <div className="h-16 bg-gradient-to-r from-[#4f5aa3] via-[#5c67aa] to-[#6b77d4]"></div>


{/* <CookieConsent /> */}

    </>
  );
};

export default AxlFrontPage;


